var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTabRedBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFCDCE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#FFE6E7",
    strokeWidth: 5.33333
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2622_200361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6654 18.333L25.132 12.8663M25.6654 15.533V12.333H22.4654M18.332 12.333H16.9987C13.6654 12.333 12.332 13.6663 12.332 16.9997V20.9997C12.332 24.333 13.6654 25.6663 16.9987 25.6663H20.9987C24.332 25.6663 25.6654 24.333 25.6654 20.9997V19.6663",
    stroke: "#FF5A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2622_200361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTabRedBg);
export default __webpack_public_path__ + "static/media/new-tab-red-bg.6905abfc255c0f4a8ebc68ef1d0034b3.svg";
export { ForwardRef as ReactComponent };